import React from 'react';
import { Person } from '@gjensidige/builders-icons';
import { Commercial } from '@gjensidige/builders-icons/products';
import { clientIdentification } from '@gjensidige/service-client-identification';

import { WindowLinkKeys } from '../../../types';
import { useUserState } from '../hooks/useUserState';
import { getUrlFromWindow, IS_BEDRIFT, IS_PRIVAT, mappedBedrifter } from '../utils/utils';

export const NavDropdownContent = () => {
  const { data: user } = useUserState();
  const { commercial } = mappedBedrifter ?? {};
  //If user is in a commercial context,  do not display currently selected bedrift in the dropdown - as it's already shown in the navigation.
  const filteredBedrifter = (
    IS_BEDRIFT
      ? commercial?.filter((bedrift) => bedrift.partref !== clientIdentification.getSelectedPartref())
      : commercial
  )?.sort((a, b) => a.navn.localeCompare(b.navn));

  return [
    !IS_PRIVAT
      ? {
          icon: <Person />,
          label: user?.fullname,
          href: `${getUrlFromWindow(WindowLinkKeys.KUNDEFORHOLDOVERSIKT_PRIVAT)}`,
          partref: clientIdentification.getPartref()
        }
      : undefined,
    ...(filteredBedrifter ?? []).map((bedrift) => ({
      icon: <Commercial height={24} width={24} />,
      label: bedrift.navn,
      href: `${getUrlFromWindow(WindowLinkKeys.KUNDEFORHOLDOVERSIKT_BEDRIFT)}?selectedPartrefs=${bedrift.partref}`,
      partref: bedrift.partref
    }))
  ].filter(Boolean);
};
